import { Controller } from "@hotwired/stimulus"

// Toggles the thenetwork static background image based on the current path.
export default class BackgroundImageController extends Controller {
  static HIDDEN_PATHS = ["/", "/home", "/otp"]

  connect() {
    this.applyThemeSource()
    this.update()
    document.addEventListener("turbo:load", this.update)
    document.addEventListener("turbo:frame-load", this.update)
    document.addEventListener("theme:changed", this.applyThemeSource)
  }

  disconnect() {
    document.removeEventListener("turbo:load", this.update)
    document.removeEventListener("turbo:frame-load", this.update)
    document.removeEventListener("theme:changed", this.applyThemeSource)
    document.documentElement.classList.remove("tn-bg-active")
  }

  // Swap the image between the dark/light theme assets. Falls back to the dark
  // image when the active theme has no dedicated asset.
  applyThemeSource = () => {
    const dark = this.element.dataset.imageDark || ""
    const light = this.element.dataset.imageLight || ""
    const isLight = document.documentElement.classList.contains("wlight")
    const url = (isLight ? light : dark) || dark
    if (url && this.element.getAttribute("src") !== url) {
      this.element.setAttribute("src", url)
    }
  }

  update = () => {
    const path = window.location.pathname
    const videoSkipped = document.documentElement.classList.contains("tn-video-skipped")
    const hidden = !videoSkipped && this.constructor.HIDDEN_PATHS.some(
      p => path === p || (p !== "/" && path.startsWith(p + "/"))
    )
    // Hide/show the image itself and flag the root so the app content surface
    // becomes transparent (CSS in base.html) to let the image show through.
    this.element.classList.toggle("hidden", hidden)
    document.documentElement.classList.toggle("tn-bg-active", !hidden)
  }
}
